import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import useTranslate from 'modules/local/useTranslate'
import {NotificationActionTypes, successNotify,} from '../../factory/createNotification'
import {shop_createNewCatalog_Api, shop_deleteCatalog_Api, shop_updateCatalog_Api} from "../../../../apis";
import {NullAsDefault} from "../../../Shared";
import {notifyOnError} from "../../factory/createErrorEvent";

const useProductCatalogActions = ({
                                      notifyListeners = {
                                          onRefresh: undefined,
                                          onCancel: undefined
                                      },
                                  }) => {
    const t = useTranslate()

    const {
        onRefresh = NullAsDefault,
        onCancel = NullAsDefault
    } = notifyListeners ?? {}

    const onError = notifyOnError(t)

    const {handleAsyncAction: createNewCatalog} = useAsyncAction({
        apiInfo: shop_createNewCatalog_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.CREATE, t)
            onRefresh()
        },
    })

    const {handleAsyncAction: updateCatalogInfo} = useAsyncAction({
        apiInfo: shop_updateCatalog_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.UPDATE, t)
            onCancel()
        },
    })

    const {handleAsyncAction: deleteCatalog} = useAsyncAction({
        apiInfo: shop_deleteCatalog_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.DELETE, t)
            onRefresh()
        },
    })


    return {
        createNewCatalog,
        updateCatalogInfo,
        deleteCatalog
    }
}

export default useProductCatalogActions
